import classnames from 'classnames';

import styles from './MenuIcon.module.scss';

interface Props {
  className?: string,
  color?: string,
  open?: boolean
}

const MenuIcon = (props: Props) => {
  const {
    className,
    color = styles.colorWhite,
    open,
  } = props;

  const classes = classnames(
    styles.icon,
    { [styles.open]: open },
    className,
  );

  return (
    <div className={classes}>
      <span className={styles.line} style={{ backgroundColor: color }} />
      <span className={styles.line} style={{ backgroundColor: color }} />
      <span className={styles.line} style={{ backgroundColor: color }} />
      <span className={styles.line} style={{ backgroundColor: color }} />
    </div>
  );
};

export default MenuIcon;
